'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MPPImage = function MPPImage(props) {
  if (!props.src) {
    return null;
  }

  var classes = (0, _classnames2.default)(props.name + '__' + props.element, props.className);
  return _react2.default.createElement('img', _extends({}, props, { src: props.src, alt: props.alt, className: classes }));
};

MPPImage.defaultProps = {
  className: '',
  name: 'organism',
  element: 'image',
  alt: ''
};

MPPImage.propTypes = {
  src: _propTypes2.default.string.isRequired,
  alt: _propTypes2.default.string,
  name: _propTypes2.default.string,
  element: _propTypes2.default.string,
  className: _propTypes2.default.string
};

exports.default = MPPImage;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/image/jsx/MPPImage.js
// module id = 660
// module chunks = 4